import type {StepStatus} from 'src/v2/components/common/StepProgressIndicator';

export function getStepStatuses(
  maxRelayRequestStatus: string | null,
  sessionState: string,
): StepStatus[] {
  if (sessionState === 'fulfillment_complete') {
    return ['completed', 'completed'];
  }
  if (
    maxRelayRequestStatus === 'failure' ||
    maxRelayRequestStatus === 'refund' ||
    sessionState === 'error' ||
    sessionState === 'failed'
  ) {
    return ['completed', 'failed'];
  }
  if (
    sessionState === 'purchase_complete' ||
    maxRelayRequestStatus === 'pending' ||
    maxRelayRequestStatus === 'submitted' ||
    maxRelayRequestStatus === 'success'
  ) {
    return ['completed', 'inProgress'];
  }
  if (maxRelayRequestStatus === 'depositing') {
    return ['inProgress', 'inProgress'];
  }
  return ['inProgress', 'inProgress'];
}

export function getRefundStepStatus(
  maxRelayRequestStatus: string | null,
): StepStatus {
  if (maxRelayRequestStatus === 'refund') {
    return 'completed';
  }
  return 'inProgress';
}
